import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPinterestComponent } from './simple-icons-pinterest.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPinterestComponent ],
    exports:      [ SimpleIconsPinterestComponent ],
    bootstrap:    []
})
export class SimpleIconsPinterestModule {}
